import React from 'react';
import './Button.css';

const Button = ({
    children,
    variant = 'primary',
    size = 'md',
    disabled = false,
    loading = false,
    onClick,
    type = 'button',
    className = '',
    href,
    target,
    rel,
    ...props
}) => {
    const buttonClass = `
    button 
    button--${variant} 
    button--${size}
    ${disabled || loading ? 'button--disabled' : ''}
    ${className}
  `.trim();

    const content = (
        <React.Fragment>
            {loading && <span className="button__spinner animate-spin">⏳</span>}
            <span className={loading ? 'button__text-hidden' : 'button__content'}>
                {children}
            </span>
        </React.Fragment>
    );

    if (href) {
        return (
            <a
                href={href}
                className={buttonClass}
                target={target}
                rel={target === '_blank' ? 'noopener noreferrer' : rel}
                aria-busy={loading}
                {...props}
            >
                {content}
            </a>
        );
    }

    return (
        <button
            type={type}
            className={buttonClass}
            onClick={onClick}
            disabled={disabled || loading}
            aria-busy={loading}
            {...props}
        >
            {content}
        </button>
    );
};

export default Button;
